import React from "react";
import { gql, useQuery } from "@apollo/client";

const USER_AVAILABLE_VIDEOS = gql`
  query MyStats {
    myStats {
      totalAvailableVideos
    }
  }
`;

function AvailableVideos() {
  const { data, loading, error } = useQuery(USER_AVAILABLE_VIDEOS);
  
  if (loading)
    return (
      <p className="text-lg" aria-live="polite">
        Loading available videos...
      </p>
    );
  if (error)
    return (
      <p className="text-lg text-red-400" aria-live="assertive">
        Error loading available videos
      </p>
    );

  const totalAvailableVideos = data?.myStats?.totalAvailableVideos ?? 0;
  const label =
    totalAvailableVideos === 1
      ? "new video to annotate!"
      : "new videos to annotate!";

}

export default AvailableVideos;
